import { IntlShape } from 'react-intl'
import { create, enforce, group, omitWhen, test } from 'vest'
import {
  type BuyAndWinBenefit,
  BuyAndWinBenefitVariant,
  BuyAndWindEffectKeys,
  type BuyAndWinFreeShipping,
  type BuyAndWinGift,
  type MaximumUnitPriceDiscount,
} from '../../../../../typings'
import { validationShippingVariantSuite as validationFreeShipping } from '../../../../ShippingVariantSelector/validation'
import { validationSuite as validationGift } from './Editor/Gift/validation'
import { validationSuite as validationMaxPrice } from './Editor/MaxPrice/validation'

export function suite(intl: IntlShape) {
  return create((benefit: BuyAndWinBenefit) => {
    group(BuyAndWindEffectKeys.BENEFIT, () => {
      test('empty', () => {
        enforce(benefit?.type).isNotEmpty()
      })

      omitWhen(!benefit?.type, () => {
        omitWhen(benefit.type !== BuyAndWinBenefitVariant.GIFT, () => {
          validationGift(intl)(benefit as BuyAndWinGift)
        })

        omitWhen(benefit.type !== BuyAndWinBenefitVariant.FREE_SHIPPING, () => {
          validationFreeShipping(intl)(benefit as BuyAndWinFreeShipping)
        })

        omitWhen(
          benefit.type !== BuyAndWinBenefitVariant.MAXIMUM_UNIT_PRICE_DISCOUNT,
          () => {
            validationMaxPrice(intl)(benefit as MaximumUnitPriceDiscount)
          }
        )
      })
    })
  })
}
